/* ==========================================================================
   DIIP DECISION GUIDE — Accordion เปิดได้ทีละข้อเดียว
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-decision-accordion]').forEach(function (accordion) {
    var items = accordion.querySelectorAll('[data-decision-item]');

    function setPanelHeight(item, isOpen) {
      var panel = item.querySelector('[data-decision-panel]');
      if (!panel) return;
      if (isOpen) {
        // ใช้ scrollHeight จริงของเนื้อหา ไม่ใช้ "auto" ตรงๆ เพราะ CSS
        // animate max-height:auto ไม่ได้ ต้องคำนวณความสูงจริงเป็น px เสมอ
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0px';
      }
    }

    function openItem(targetItem) {
      items.forEach(function (item) {
        var toggleBtn = item.querySelector('[data-decision-toggle]');
        var isTarget = item === targetItem;
        item.classList.toggle('is-open', isTarget);
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
        setPanelHeight(item, isTarget);
      });
    }

    function closeItem(targetItem) {
      targetItem.classList.remove('is-open');
      var toggleBtn = targetItem.querySelector('[data-decision-toggle]');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      setPanelHeight(targetItem, false);
    }

    items.forEach(function (item) {
      var toggleBtn = item.querySelector('[data-decision-toggle]');
      if (!toggleBtn) return;

      toggleBtn.addEventListener('click', function () {
        var alreadyOpen = item.classList.contains('is-open');
        if (alreadyOpen) {
          closeItem(item); // คลิกข้อที่เปิดอยู่ซ้ำ = หุบได้ ไม่ต้องมีอะไรเปิดค้างไว้เสมอ
        } else {
          openItem(item); // เปิดข้อนี้ = หุบข้ออื่นทั้งหมดอัตโนมัติ (Accordion เปิดได้ทีละอันเดียว)
        }
      });
    });

    // ตั้งความสูงเริ่มต้นให้ตรงกับข้อที่เปิดอยู่ตั้งแต่โหลดหน้าเว็บ (is-open จาก Liquid)
    items.forEach(function (item) {
      setPanelHeight(item, item.classList.contains('is-open'));
    });

    // ปรับความสูง Panel ที่เปิดอยู่ใหม่ตอน resize จอ (เผื่อเนื้อหา wrap เปลี่ยนบรรทัดจนความสูงเปลี่ยน)
    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) setPanelHeight(item, true);
      });
    });
  });
});
